export {
    Type,
    instanceOf,
    fromDate,
    toDate,
    JSON_DISCRIMINATOR,
    Serializable,
    toTypedJSON,
    toUnwrappedJSON,
    fromUnwrappedJSON,
    fromTypedJSON,
    toSerializable,
    fromSerializable,
    SchemaValue,
    toSchemaValue,
    fromSchemaValue,
    fromMillis,
    futureMinutes,
} from '../../types/Timestamp.js';
